import React, { useEffect, useMemo, useState } from 'react'

import SimpleTable from './SimpleTable'
import { lrHeaders } from './constants'
import { safeAdd } from '../../common/mathHelper'

const emptySearchData = {
  LRNO: '',
  SourceCity: '',
  SourceBranch: '',
  DestinationCity: '',
  DestinationBranch: '',
  SinceDays: '',
  SinceDateShow: '',
}

const LRTable = ({
  rows = [],
  mode = 'add',
  onSelectionChange,

  showTotals = true,

  totalLabel = 'TOTAL',
}) => {
  const [searchData, setSearchData] = useState(emptySearchData)
  const rowIdentity = useMemo(
    () => rows.map((row) => row.BookingID).join(','),
    [rows]
  )

  useEffect(() => {
    setSearchData(emptySearchData)
  }, [rowIdentity])

  const filteredRows = useMemo(() => {
    return rows.filter((val) =>
      Object.keys(searchData).every(
        (key) =>
          searchData[key] === '' ||
          val[key]
            ?.toString()
            .toLowerCase()
            .includes(searchData[key].toString().toLowerCase())
      )
    )
  }, [rows, searchData])

  const handleSearchData = (event, field) => {
    setSearchData((prevData) => ({ ...prevData, [field]: event.target.value }))
  }

  const totals = useMemo(() => {
    return filteredRows.reduce(
      (acc, row) => {
        acc.Items = safeAdd(acc.Items, row.Items)
        acc.Weight = safeAdd(acc.Weight, row.Weight)
        acc.Freight = safeAdd(acc.Freight, row.Freight)
        acc.OtherCharges = safeAdd(acc.OtherCharges, row.OtherCharges)
        acc.GST = safeAdd(acc.GST, row.GST)
        acc.TotalAmount = safeAdd(acc.TotalAmount, row.TotalAmount)

        return acc
      },
      {
        Items: 0,
        Weight: 0,
        Freight: 0,
        OtherCharges: 0,
        GST: 0,
        TotalAmount: 0,
        colSpan: {
          select: 8,
        },
      }
    )
  }, [filteredRows])

  return (
    <SimpleTable
      headers={lrHeaders}
      data={filteredRows}
      mode={mode}
      onCheck={onSelectionChange}
      searchData={searchData}
      onSearchChange={handleSearchData}
      showTotals={showTotals}
      totals={totals}
      totalLabel={totalLabel}
      minWidth={1450}
    />
  )
}

export default LRTable
